// extracted by mini-css-extract-plugin
export default {"block":"Wd","smallprint":"Xd","asterisk":"Yd","label":"Zd"};